import React from 'react';

let YEARS = [];
let YEARS_AS_OPTIONS = [];

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
for (let i = 0; i < 11; i++ ) {
    YEARS.push(currentYear + i);
    YEARS_AS_OPTIONS.push(
        <option key={currentYear + i} value={currentYear + i}>{currentYear + i}</option> 
    );
}

export {
    YEARS,
    YEARS_AS_OPTIONS,
}



// WEBPACK FOOTER //
// ./src/components/billing-form/constants/years.js